export const REACT_ROOT = 'root';
export const BREAKPOINT_SMALL = `(max-width: ${600}px)`;
export const BREAKPOINT_MEDIUM = `(max-width: ${850}px)`;
export const BREAKPOINT_LARGE = `(max-width: ${1024}px)`;
export const BREAKPOINT_EXTRA_LARGE = `(max-width: ${1280}px)`;
